import React, { useState, useEffect } from 'react';

const RealWorldFocusReveal = ({ onContinue }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showContinue, setShowContinue] = useState(false);
  const [iq, setIq] = useState(1004);
  
  const realWorldText = `And we kindly remind you, this is not so much about a game, it's about how play leads to projects and people IRL`;

  // IQ flickering effect
  useEffect(() => {
    const iqInterval = setInterval(() => {
      setIq(prev => 1004 + Math.floor(Math.random() * 20) - 10); // Fluctuate around 1004
    }, 300);
    
    return () => clearInterval(iqInterval);
  }, []);

  useEffect(() => {
    if (currentIndex < realWorldText.length) {
      const timer = setTimeout(() => {
        setDisplayedText(prev => prev + realWorldText[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, 45); // Thoughtful typing speed
      
      return () => clearTimeout(timer);
    } else {
      // Show continue button after typing is complete
      const continueTimer = setTimeout(() => {
        setShowContinue(true);
      }, 1500);
      
      return () => clearTimeout(continueTimer);
    }
  }, [currentIndex, realWorldText]);

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-4xl">
        
        {/* IQ Display */}
        <div className="text-center mb-8">
          <div 
            className="text-green-400 font-mono text-lg"
            style={{ 
              fontFamily: 'Courier New, monospace',
              textShadow: '0 0 15px rgba(34, 197, 94, 0.8)'
            }}
          >
            <span className="animate-pulse">► CURRENT IQ: {iq} ◄</span>
          </div>
        </div>
        
        <pre 
          className="text-green-400 font-mono text-xl leading-relaxed whitespace-pre-wrap text-center"
          style={{ 
            fontFamily: 'Courier New, monospace',
            textShadow: '0 0 10px rgba(34, 197, 94, 0.5)'
          }}
        >
          {displayedText}
          {currentIndex < realWorldText.length && (
            <span className="animate-pulse">█</span>
          )}
        </pre>
        
        {showContinue && (
          <div className="text-center mt-12">
            <button
              onClick={onContinue}
              className="px-12 py-4 bg-green-600/20 border border-green-400 text-green-300 font-mono text-xl hover:bg-green-600/40 transition-all duration-300"
              style={{
                textShadow: '0 0 10px rgba(34, 197, 94, 0.8)',
                boxShadow: '0 0 20px rgba(34, 197, 94, 0.3)'
              }}
            >
              [BEGIN REALITY CREATION] →
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RealWorldFocusReveal;